export default defineNuxtPlugin(async () => {
  const productContentDatalessRoutes: string[] = ['/hc'];
  if (productContentDatalessRoutes.includes(useRoute().path)) {
    return;
  }

  const { fetchProductContents } = useProductContent();

  await fetchProductContents();
});
